import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'hooks/useTranslation';

import { GiftCardEditorForm } from 'features/my-gift-cards/components/GiftCardEditorForm';
import { useStyles } from 'features/get-started/components/styles';
import useAuth from 'features/auth/hooks/useAuth';
import BaseButton from 'features/app/components/BaseButton';
import { getStartedPaths } from 'features/get-started/routes/paths';
import useGetStarted from 'features/get-started/hooks/useGetStarted';
import i18n from 'locales/i18n';

export const FirstStep = () => {
  const { user } = useAuth();
  const direction = i18n.dir();

  const classes = useStyles({ direction });
  const { t } = useTranslation('get-started');
  const { onHandleSkipAndNext, backToDashboard } = useGetStarted();

  return (
    <Grid container justifyContent={'space-between'} className={classes.root} wrap={'nowrap'}>
      <Grid className={classes.leftBlockWrapper}>
        <Typography className={classes.stepTitle}>{t('step')} 1/2</Typography>
        <Typography className={classes.name}>
          {t('hi')} <br />
          {user?.first_name} {user?.last_name}
        </Typography>

        <Typography className={classes.title} variant={'h2'}>
          {t('createYourFirstReward')}
        </Typography>
        <Typography className={classes.subtitle}>{t('setupYourFirstReward')}</Typography>

        <Grid container wrap={'nowrap'}>
          <BaseButton className={classes.skipBtn} variant={'text'} onClick={backToDashboard}>
            {t('skip')}
          </BaseButton>
          <BaseButton className={classes.skipAndNextBtn} onClick={onHandleSkipAndNext}>
            {t('skipAndNext')}
          </BaseButton>
        </Grid>
      </Grid>

      <Grid className={classes.formWrapper}>
        <GiftCardEditorForm redirectPath={getStartedPaths.static.secondStep} isHidePreview={true} />
      </Grid>
    </Grid>
  );
};
